import api from 'COMMONS/api/webrtc_history';

const recordWebrtcHistory = (actionType, data) => {
  const { answerConnectivityId, browserTestHistoryId } = document.querySelector('#webrtc_history_config').dataset;
  return api({ answerConnectivityId, browserTestHistoryId }, actionType, data).catch((_error) =>
    console.error(_error),
  );
};

export default recordWebrtcHistory;
